import TableCrud from '../../components/TableCrud';
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/auth';
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import TableLoading from '../../components/TableLoading/index';
import { error_message } from '../../components/Toast/index.jsx';
import Api, { exceptionNotificationAPI } from '../../services/api';
import { Container, Table } from './styles';
import { formSelectStyles, formSelectControlFullWidth } from '../../components/FormInput/formSelectStyles';

const MigrateDashboard = () => {

    const { user, userRoles } = useAuth();
    const { companyID, reportYearID, moduleID } = useParams();

    const [cultureID] = useState(localStorage.getItem('@Thrive:cultureID'));

    const [userObject, setUserObject] = useState(null);
    const [loading, setLoading] = useState(true);
    const [loadingView, setLoadingView] = useState(false);

    const [blockToYear, setBlockToYear] = useState(false);

    //Operation Select Variables
    const [selectedOperation, setSelectedOperation] = useState();
    const [operations, setOperations] = useState('');

    //Report Year Select Variables
    const [reportYearList, setReportYearList] = useState([]);
    const [fromReportYear, setFromReportYear] = useState('');
    const [toReportYear, setToReportYear] = useState('');

    useEffect(() => {
        var userAux = typeof (user) == "string" ? JSON.parse(user) : user;
        setUserObject(userAux);
        loadCropYears(userAux);
        loadOperations(userAux.selectedReportYearID);
        setLoading(false);
    }, []);

    const loadCropYears = () => {
        Api.get(`thriveValue/getAllCropsYears?selectedCulture=${cultureID}`).then((result) => {
            setLoading(true);
            if (result && result.data) {
                setReportYearList(result.data.response);
            }
            setLoading(false);
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    const loadOperations = (reportYearID) => {
        Api.get(`thriveValue/getAllOperationsByReportYear?reportYearID=${reportYearID}`).then((result) => {
            if (result && result.data) {
                let response = result.data.response;
                if (response.length > 0) {
                    setOperations(response);
                } else {
                    response.push({
                        operationID: "",
                        description: `No items found, please select another Report Year`,
                    })
                    setOperations(response);
                }

                setLoading(false);
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    const onChangeOperation = (value) => {
        setSelectedOperation(value);
        setBlockToYear(true);
    }

    const onChangeFromReportYearID = (value) => {
        setFromReportYear(value);

        // Desbloqueia o terceiro select apenas se o valor selecionado for maior que 0
        setBlockToYear(value <= 0);
        setToReportYear(value <= 0 ? 0 : toReportYear);

        if (value > 0) {
            var year = reportYearList.find(x => x.reportYearID == value);
            var nextYear = (parseInt(year.year) + 1);
            var nextReportYear = reportYearList.find(x => x.year == nextYear);
            setToReportYear(nextReportYear?.reportYearID ? nextReportYear?.reportYearID : 0);
        }
    }

    const onChangeToReportYearID = (value) => {
        setToReportYear(value);
    }

    const migrateStructure = () => {
        setLoadingView(true);

        if (selectedOperation && fromReportYear && toReportYear) {
            Api.get(`migrate/MigrateStructure?selectedOperation=${selectedOperation}&fromReportYear=${fromReportYear}&toReportYear=${toReportYear}`).then((result) => {
                if (result && result.data) {
                    setLoadingView(false);
                }
                setLoadingView(false);
            }).catch((error) => {
                setLoadingView(false);
                exceptionNotificationAPI(error);
            });
        } else {
            error_message("Error ocurred during migration");
            setLoadingView(false);
        }
    }

    return (
        <Container className="container">
            <div className="row mt-2">
                <div className="col-md-12 mt-2" style={{ width: '100%' }}>
                    <Select
                        options={Array.isArray(operations) ? operations.map((o) => ({ value: o.operationID, label: o.description })) : []}
                        value={Array.isArray(operations) && operations.find((o) => o.operationID === selectedOperation) ? { value: selectedOperation, label: operations.find((o) => o.operationID === selectedOperation).description } : null}
                        onChange={(x) => onChangeOperation(x?.value ?? '')}
                        placeholder="Select form to migrate"
                        isSearchable
                        isClearable={false}
                        styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                        classNamePrefix="migrate-operation"
                    />
                </div>
                <div className="col-md-12 mt-2" style={{ width: '100%' }}>
                    <Select
                        options={reportYearList?.map((y) => ({ value: y.reportYearID, label: y.year })) ?? []}
                        value={reportYearList?.find((y) => y.reportYearID === fromReportYear) ? { value: fromReportYear, label: reportYearList.find((y) => y.reportYearID === fromReportYear).year } : null}
                        onChange={(x) => onChangeFromReportYearID(x?.value ?? '')}
                        placeholder="Select Report Year to copy from"
                        isSearchable
                        isClearable={false}
                        styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                        classNamePrefix="migrate-fromyear"
                    />
                </div>
                <div className="col-md-12 mt-2" style={{ width: '100%' }}>
                    <Select
                        options={reportYearList?.map((y) => ({ value: y.reportYearID, label: y.year })) ?? []}
                        value={reportYearList?.find((y) => y.reportYearID === toReportYear) ? { value: toReportYear, label: reportYearList.find((y) => y.reportYearID === toReportYear).year } : null}
                        onChange={(x) => onChangeToReportYearID(x?.value ?? '')}
                        isDisabled
                        placeholder="Select Report Year to copy to"
                        isSearchable
                        isClearable={false}
                        styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                        classNamePrefix="migrate-toyear"
                    />
                </div>
                {
                    loadingView ?
                        <div className="mt-2" style={{ padding: 0 }}>
                            <TableLoading />
                        </div> : <button className="col-md-12 apply-btn mt-2" onClick={() => migrateStructure()}>Migrate</button>
                }

            </div>
        </Container>
    );
}

export default MigrateDashboard;
